<div class="checkmark" [style.width]="size">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        xml:space="preserve" x="0px" y="0px" viewBox="0, 0, 100, 100" id="checkmark">
        <g transform="">
            <circle class="path" [class.success]="!endLoading" [class.path-complete]="!loading" fill="none"
                stroke="var(--clara-alternative)" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="44" />
            <circle class="fill" [class.success]="!endLoading" [class.fill-complete]="!loading" fill="none"
                stroke="var(--clara-alternative)" stroke-width="4" stroke-miterlimit="10" cx="50" cy="50" r="44" />
            <polyline class="check" [class.success]="!endLoading" [class.check-complete]="!loading" fill="none"
                stroke="var(--clara-alternative)" stroke-width="8" stroke-linecap="round" stroke-miterlimit="10"
                points="70,35 45,65 30,52  " />
        </g>
    </svg>

</div>
